var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicrophone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20_1008)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7145 11.4769C10.2473 10.9197 9.08028 9.75274 8.52311 8.28548L2.94033 16.3107L3.68927 17.0597L11.7145 11.4769ZM8.22985 5.49666C8.63287 2.85619 10.9135 0.833374 13.6666 0.833374C16.7042 0.833374 19.1666 3.29581 19.1666 6.33337C19.1666 9.08647 17.1438 11.3671 14.5033 11.7701L3.4773 19.4404L0.55957 16.5227L8.22985 5.49666ZM16.8949 8.0735C17.1745 7.55576 17.3333 6.96311 17.3333 6.33337C17.3333 4.30833 15.6917 2.66671 13.6666 2.66671C13.0308 2.66671 12.4327 2.82856 11.9114 3.1133C12.1887 3.97857 13.1425 5.42951 13.8565 6.14353C14.5588 6.84587 15.9847 7.77832 16.8949 8.0735ZM15.5303 9.49177C14.9842 9.81471 14.347 10 13.6666 10C11.6416 10 9.99995 8.35842 9.99995 6.33337C9.99995 5.65911 10.1819 5.02735 10.4995 4.48455C11.0098 5.56985 11.8286 6.70837 12.5601 7.43989C13.2822 8.16202 14.431 8.97892 15.5303 9.49177Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20_1008"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophone);
export default __webpack_public_path__ + "static/media/microphone.fed68163.svg";
export { ForwardRef as ReactComponent };